export default "__VITE_ASSET__4c05974b__"